'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface ContactMethod {
  id: string;
  icon: string;
  title: string;
  description: string;
  value: string;
  responseTime: string;
  action: string;
  scrollTo?: string;
}

interface ContactMethodsProps {
  className?: string;
}

const ContactMethods = ({ className = '' }: ContactMethodsProps) => {
  const handleScrollTo = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const contactMethods: ContactMethod[] = [
    {
      id: '2',
      icon: 'EnvelopeIcon',
      title: 'Contact Us to Receive a Quote',
      description: 'Detailed inquiries and documentation',
      value: 'info@consultintech.com',
      responseTime: 'Within 4 hours',
      action: 'Send Email',
      scrollTo: 'contact-form-section'
    }
  ];

  return (
    <section className={`py-16 bg-background ${className}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-foreground mb-4">
            Choose Your Preferred Contact Method
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            We offer multiple ways to connect, ensuring you can reach us through your preferred channel with guaranteed response times.
          </p>
        </div>

        <div className="flex justify-center">
          <div className="max-w-md w-full">
            {contactMethods.map((method) => (
              <div
                key={method.id}
                className="bg-card rounded-lg p-6 border border-border hover:shadow-elevation transition-all duration-300 ease-brand group"
              >
                <div className="w-14 h-14 bg-primary/10 rounded-full flex items-center justify-center mb-4 group-hover:bg-primary group-hover:scale-110 transition-all duration-300">
                  <Icon name={method.icon as any} size={28} className="text-primary group-hover:text-white transition-colors duration-300" />
                </div>
                <h3 className="text-xl font-display font-semibold text-foreground mb-2">
                  {method.title}
                </h3>
                <p className="text-sm text-muted-foreground mb-4">
                  {method.description}
                </p>
                <div className="space-y-2 mb-4">
                  <p className="text-sm font-semibold text-foreground">
                    {method.value}
                  </p>
                  <div className="flex items-center space-x-2">
                    <Icon name="ClockIcon" size={16} className="text-success" />
                    <p className="text-xs text-muted-foreground">
                      {method.responseTime}
                    </p>
                  </div>
                </div>
                <button 
                  onClick={() => method.scrollTo && handleScrollTo(method.scrollTo)}
                  className="w-full py-2 px-4 bg-primary text-primary-foreground rounded-md text-sm font-semibold hover:bg-primary/90 transition-colors duration-300 ease-brand"
                >
                  {method.action}
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactMethods;